import { Locales } from '@monoimin/sb-types';

export function handleInputLabel(
  label: string,
  isRequired: boolean,
  locale: Locales
): string {
  if (isRequired) {
    return label;
  }

  return `${label} (${locale === 'ru' ? 'необязательно' : 'optional'})`;
}

export default handleInputLabel;
